import { APP_LANGUAGES_ENUM } from 'config/constants';

export const AUDIO_PATH = {
  [APP_LANGUAGES_ENUM.am]: 'armenian',
  [APP_LANGUAGES_ENUM.ku]: 'kurdish',
  [APP_LANGUAGES_ENUM.ru]: '',
  [APP_LANGUAGES_ENUM.en]: '',
};
